document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-switcher]').forEach((root) => {
    root.querySelectorAll('[data-hero-option]').forEach((option) => option.addEventListener('click', () => {
      const id = option.dataset.heroOption;
      root.querySelectorAll('[data-hero-option]').forEach((item) => { item.classList.toggle('is-active', item === option); item.setAttribute('aria-pressed', item === option ? 'true' : 'false'); });
      root.querySelectorAll('[data-hero-meta]').forEach((item) => { item.hidden = item.dataset.heroMeta !== id; item.classList.toggle('is-active', item.dataset.heroMeta === id); });
      root.querySelectorAll('[data-hero-image]').forEach((item) => { item.hidden = item.dataset.heroImage !== id; item.classList.toggle('is-active', item.dataset.heroImage === id); });
    }));
  });

  const wholesaleDialog = document.querySelector('[data-wholesale-dialog]');
  document.querySelectorAll('[data-wholesale-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
    if (!wholesaleDialog) return;
    event.preventDefault();
    wholesaleDialog.showModal();
  }));
  document.querySelectorAll('[data-popup-open]').forEach((trigger) => trigger.addEventListener('click', () => {
    const dialog = document.getElementById(trigger.dataset.popupOpen);
    if (dialog) dialog.showModal();
  }));
  document.querySelectorAll('.theme-dialog').forEach((dialog) => {
    dialog.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });
  if (wholesaleDialog && wholesaleDialog.querySelector('.form-success, .errors')) wholesaleDialog.showModal();
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const root = select.closest('[data-product-root]');
      const price = root && root.querySelector('[data-product-price]');
      const button = root && root.querySelector('[data-add-button]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const mainImage = root && root.querySelector('.product-main-image img');
      if (mainImage && option.dataset.image) {
        mainImage.src = option.dataset.image;
        mainImage.srcset = '';
        mainImage.alt = option.dataset.imageAlt || '';
      }
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
      }
    });
  });

  document.querySelectorAll('[data-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-gallery]');
      const main = root && root.querySelector('.product-main-image img');
      if (main) {
        main.src = button.dataset.image;
        main.srcset = '';
        main.alt = button.dataset.alt || '';
      }
      root.querySelectorAll('[data-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const title = root.querySelector('[data-product-title]');
    const description = root.querySelector('[data-product-description]');
    if (!title || !description) return;
    const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
    const firstTextElement = description.querySelector('h1, h2, h3, h4, p, strong');
    if (firstTextElement && (!normalize(firstTextElement.textContent) || normalize(firstTextElement.textContent) === normalize(title.textContent))) {
      firstTextElement.remove();
    }
  });
});
